var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[_c('h3',{staticClass:"text-center"},[_vm._v(_vm._s(this.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }